import { useState } from "react";
import { Navigate, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, loading, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  if (!loading && user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) navigate("/admin");
    else setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-screen bg-[#FFFDF9] flex items-center justify-center p-6" data-testid="login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 justify-center mb-8" data-testid="login-brand">
          <span className="text-3xl">🦡</span>
          <span className="font-headings text-2xl font-bold">
            Jungle <span className="text-[#FF5A5F]">Badger</span>
          </span>
        </Link>

        <div className="bg-white border-4 border-[#1E1E24] rounded-3xl p-8 md:p-10">
          <h1 className="font-headings text-3xl font-bold text-[#1E1E24] mb-2">Admin login</h1>
          <p className="text-[#5E5E66] mb-6">Manage products & leads.</p>

          <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
            <div>
              <label className="block text-sm font-bold uppercase tracking-wider mb-1.5 text-[#1E1E24]">
                Email
              </label>
              <input
                data-testid="login-email-input"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 rounded-full border-2 border-[#1E1E24] bg-white focus:outline-none focus:ring-4 focus:ring-[#FFB400] focus:ring-offset-2 focus:ring-offset-white font-medium"
                placeholder="you@junglebadger.com"
                autoComplete="username"
              />
            </div>
            <div>
              <label className="block text-sm font-bold uppercase tracking-wider mb-1.5 text-[#1E1E24]">
                Password
              </label>
              <input
                data-testid="login-password-input"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-full border-2 border-[#1E1E24] bg-white focus:outline-none focus:ring-4 focus:ring-[#FFB400] focus:ring-offset-2 focus:ring-offset-white font-medium"
                placeholder="••••••••"
                autoComplete="current-password"
              />
            </div>
            {error && (
              <p data-testid="login-error" className="text-[#FF5A5F] font-semibold text-sm">
                {error}
              </p>
            )}
            <button
              data-testid="login-submit"
              type="submit"
              disabled={submitting}
              className="w-full bg-[#FF5A5F] text-white border-2 border-[#1E1E24] rounded-full shadow-[4px_4px_0px_0px_#1E1E24] hover:-translate-y-1 hover:shadow-[6px_6px_0px_0px_#1E1E24] transition-all font-bold tracking-wide px-8 py-3 disabled:opacity-60"
            >
              {submitting ? "Signing in..." : "Sign in"}
            </button>
          </form>
        </div>

        <p className="text-center text-sm text-[#5E5E66] mt-6">
          <Link to="/" className="hover:text-[#1E1E24] font-bold" data-testid="login-back-home">
            ← Back to site
          </Link>
        </p>
      </div>
    </div>
  );
}
